"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-desktop
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.71
 * Contact: bithighlander@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTCInputScriptTypeToJSON = exports.BTCInputScriptTypeFromJSONTyped = exports.BTCInputScriptTypeFromJSON = exports.BTCInputScriptType = void 0;
/**
 *
 * @export
 */
exports.BTCInputScriptType = {
    Cashaddr: 'cashaddr',
    Bech32: 'bech32',
    P2pkh: 'p2pkh',
    P2sh: 'p2sh',
    External: 'external',
    P2wpkh: 'p2wpkh',
    P2shP2wpkh: 'p2sh-p2wpkh'
};
function BTCInputScriptTypeFromJSON(json) {
    return BTCInputScriptTypeFromJSONTyped(json, false);
}
exports.BTCInputScriptTypeFromJSON = BTCInputScriptTypeFromJSON;
function BTCInputScriptTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BTCInputScriptTypeFromJSONTyped = BTCInputScriptTypeFromJSONTyped;
function BTCInputScriptTypeToJSON(value) {
    return value;
}
exports.BTCInputScriptTypeToJSON = BTCInputScriptTypeToJSON;
